import React from 'react';
import { Grid, ColorOption, Label, Field } from './styles';

export const PREDEFINED_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD',
  '#D4A5A5', '#9B59B6', '#3498DB', '#E67E22', '#2ECC71',
  '#E74C3C', '#1ABC9C', '#F1C40F', '#34495E', '#95A5A6',
  '#16A085', '#27AE60', '#2980B9', '#8E44AD', '#F39C12'
];

const NodeColorPicker = ({ selectedColor, onColorSelect }) => {
  return (
    <Field>
      <Label>Node Color</Label>
      <Grid>
        {PREDEFINED_COLORS.map((color) => (
          <ColorOption
            key={color}
            color={color}
            selected={selectedColor === color}
            onClick={() => onColorSelect(color)}
            type="button"
            aria-label={`Select color ${color}`}
          />
        ))}
      </Grid>
    </Field>
  );
};

export default NodeColorPicker;
